import React from "react";
import { useHistory } from "react-router-dom";

import { createStyles, makeStyles } from "@material-ui/core/styles";
import { Typography } from "@mui/material";

import Container from "../../components/Container";
import accessDenied from "../../assets/images/accessDenied.png";
import Button from "../../components/Button";
import theme from "../../constants/theme";
import { routes } from "../../api/paths";
import MetaDecorator from "../../components/MetaDecorator";

const useStyles = makeStyles(() =>
  createStyles({
    root: {
      height: "100vh",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      flexDirection: "column",
    },
    img: {
      width: "30rem",
      display: "block",
      marginBottom: theme.spacing(3),
      [theme.breakpoints.only("xs")]: {
        width: "20rem",
      },
    },
    subtitle: {
      padding: theme.spacing(2, 0),
      textAlign: "center",
    },
  })
);

export default function AccessDenied() {
  const classes = useStyles();
  const history = useHistory();

  return (
    <>
      <MetaDecorator />
      <Container className={classes.root}>
        <img src={accessDenied} alt="access denied" className={classes.img} />
        <Typography
          variant="h4"
          style={{ fontWeight: "bold", letterSpacing: -1 }}
        >
          Ups! Čini se da stranica ne postoji.
        </Typography>
        <Typography className={classes.subtitle}>
          Stranica nije pronađena ili nemate pravo pristupa stranici.
          <br />
          Kliknite na gumb "Prijavi se" kako biste došli na stranicu za prijavu.
        </Typography>
        <Button onClick={() => history.push(routes.LOGIN_URL)}>
          Prijavi se
        </Button>
      </Container>
    </>
  );
}
